import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COMMERCIAL_SITE } from '@connexio/shared/constants';
import { commercialContactHref, commercialOnSitePath } from '@/lib/commercialContact';
import { ConnexioLogo } from '@/components/ConnexioLogo';
import styles from './MarketingFooter.module.css';
import { cn } from '@/lib/utils';

const FOOTER_LINK_CLASS =
  cn(styles.footerLink, 'text-body-m');

export function MarketingFooter() {
  const { t } = useTranslation('marketing');
  const links: { href: string; label: string; to: string | null }[] = [];

  if (COMMERCIAL_SITE.termsUrl) {
    links.push({
      href: COMMERCIAL_SITE.termsUrl,
      label: t('footer.terms'),
      to: commercialOnSitePath(COMMERCIAL_SITE.termsUrl),
    });
  }
  if (COMMERCIAL_SITE.privacyUrl) {
    links.push({
      href: COMMERCIAL_SITE.privacyUrl,
      label: t('footer.privacy'),
      to: commercialOnSitePath(COMMERCIAL_SITE.privacyUrl),
    });
  }
  const contactHref = commercialContactHref();
  links.push({
    href: contactHref,
    label: t('footer.contact'),
    to: commercialOnSitePath(contactHref),
  });

  return (
    // Continues the closing CTA's dark band so the page ends on one dark foot
    // rather than snapping back to a light strip under a dark section.
    <footer className={cn(styles.footer, 'marketing-invert')}>
      <div className={styles.stack}>
        <div className={styles.stack2}>
          <ConnexioLogo showWordmark size={24} lightText />
          <p className={cn(styles.dataLocation, 'text-body-m')}>{t('footer.dataLocation')}</p>
        </div>

        <div className={styles.stack3}>
          {links.length > 0 ? (
            <nav aria-label={t('footer.copyright')}>
              <ul className={styles.list}>
                {links.map((link) => (
                  <li key={link.href}>
                    {link.to ? (
                      <Link to={link.to} className={FOOTER_LINK_CLASS}>
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className={FOOTER_LINK_CLASS}
                        {...(link.href.startsWith('http')
                          ? { rel: 'noreferrer', target: '_blank' }
                          : {})}
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ) : null}
          <p className={cn(styles.dataLocation, 'text-body-s')}>
            © {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
